module.exports = __webpack_public_path__ + "img/dometic_tropicool_tcx_21.4db8015a.png";